import { SLOT_VERTICAL_OFFSET } from '@app/core/cms-flex/types';

import { SlotBottomPadding } from '../types';

export const SLOT_BOTTOM_OFFSET = new Map<SLOT_VERTICAL_OFFSET, SlotBottomPadding>()
  .set(SLOT_VERTICAL_OFFSET.REM_1, 'slot-bottom-padding__1')
  .set(SLOT_VERTICAL_OFFSET.REM_2, 'slot-bottom-padding__2')
  .set(SLOT_VERTICAL_OFFSET.REM_3, 'slot-bottom-padding__3')
  .set(SLOT_VERTICAL_OFFSET.REM_4, 'slot-bottom-padding__4')
  .set(SLOT_VERTICAL_OFFSET.REM_5, 'slot-bottom-padding__5')
  .set(SLOT_VERTICAL_OFFSET.REM_6, 'slot-bottom-padding__6');
